export default "__VITE_ASSET__Cqxd82v3__"